<template>
  <div>
    <van-uploader
      v-model="fileList"
      multiple
      accept=""
      upload-text="选择文件"
      :disabled="disabled"
      :max-count="options.meta && options.meta.length"
      :before-read="beforeRead"
      :after-read="afterRead"
      @click-preview="preview"
      @delete="deleteFile"
    />
    <div v-if="isMobile" style="font-size: 14px; color: #999;">
      <!-- {{ options.type === 'fileupload' ? '只有 pdf、doc、docx、xls、xlsx、jpeg、jpg、png 格式文件允许被上传' : '只有 jpeg、jpg、png 格式图片允许被上传' }} -->
      <p>若遇微信中上传失败,请尝试上传图片或使用手机系统浏览器打开页面提交</p>
    </div>

    <van-popup v-model="showPopupLoading" get-container="body" round :close-on-click-overlay="false">
      <div style="padding: 30px;">
        <van-loading size="60px" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Uploader, Popup, Loading } from 'vant'
import { Toast } from 'vant'
import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
import { upload } from '@/mixin/file'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import { Notify } from 'vant'

export default {
  name: 'PwcUploader',
  components: {
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
    [Loading.name]: Loading
  },
  mixins: [upload],
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    delay: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasfileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileList: [].concat(this.hasfileList),
      accept: {
        uploadImgs: ['jpeg', 'jpg', 'png']
      },
      acceptMsg: {
        uploadImgs: '只有jpeg, jpg, png格式图片允许被上传'
      },
      files: {},
      fileDirs: {},
      fileType: '',
      isMobile,
      // pageLoading: false,
      showPopupLoading: false
    }
  },
  computed: {
    ...mapState(['tempFiles', 'userInfo'])
  },
  methods: {
    ...mapActions({
      saveTempFiles: Actions.SAVE_TEMP_FILES
    }),
    checkFile(file) {
      const flieArr = file.name.split('.')
      let suffix = flieArr[flieArr.length - 1] || ''
      suffix = suffix.toLowerCase()
      // 后登录的不让上传视频
      if (!this.userInfo.token) {
        if (suffix === 'mp4' || suffix === 'mov') {
          Notify({
            message: 'This survey cannot upload video.',
            duration: 5 * 1000
          })
          return false
        }
      }
      if (!this.accept[this.options.type].includes(suffix)) {
        Toast(this.acceptMsg[this.options.type])
        return false
      }
      this.fileType = ''
      if (suffix === 'mp4' || suffix === 'mov') {
        if (file.size > 209715200) { // 大于200M
          Notify({
            message: 'File size should be less than 200M.',
            duration: 5 * 1000
          })
          return false
        } else {
          this.fileType = 'video'
        }
      } else {
        if (file.size > 5242880) { // 大于5M
          Notify({
            message: 'File size should be less than 5M.',
            duration: 5 * 1000
          })
          return false
        }
      }
      if (file.size <= 0) {
        Notify({
          message: '因系统兼容问题,无法获取文件内容,请尝试使用手机系统浏览器或PC打开页面提交',
          duration: 5 * 1000
        })
        return false
      }
      return true
    },
    beforeRead(file, detail) {
      if (file) {
        if (Array.isArray(file)) {
          for (let i = 0; i < file.length - 1; i++) {
            return this.checkFile(file[i])
          }
        } else {
          return this.checkFile(file)
        }
      } else {
        Notify({
          message: '因系统兼容问题,无法获取文件内容,请尝试使用手机系统浏览器或PC打开页面提交',
          duration: 5 * 1000
        })
        return false
      }
    },
    async handleSelect(file) {
      if (this.fileType === 'video') {
        this.showPopupLoading = true
        const ossRes = await this.uploadFiles(file, 'survey_related', false)
        if (ossRes) {
          this.showPopupLoading = false
        }
        return ossRes
      } else {
        const res = await this.uploadToSys(file)
        if (res.resultCode === '0') {
          let fileUrl = ''
          if (res.data.length > 0) {
            fileUrl = res.data[0]
          }
          return fileUrl
        } else {
          Notify({
            message: '文件上传失败,请尝试使用手机系统浏览器或电脑端提交',
            duration: 3 * 1000
          })
          return ''
        }
      }
    },
    async afterRead(file, detail) {
      if (this.userInfo.token && this.userInfo.leadId) {
        this.$emit('uploaded', this.fileList)
      }
    },
    deleteFile(file, detail) {
      if (this.userInfo.token && this.userInfo.leadId) {
        this.$emit('uploaded', this.fileList)
      }
    },
    async preview(e) {
      if (typeof e === 'object') {
        if (this.fileDirs[e.file.lastModified]) {
          const allUrl = await this.getFileUrl(this.fileDirs[e.file.lastModified])
          window.open(allUrl)
        }
      } else if (typeof e === 'string') {
        const allUrl = await this.getFileUrl(e)
        window.open(allUrl)
      }
    }
  }
}
</script>
